import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '@panel/commons';
import { currencyOptionsBySite, site } from '@panel/commons/helpers';
import { formatAmount } from '@panel/commons/helpers/formatAmount';
import { specialCharactersLock } from '../../../utils/index';
import { ErrorMessage } from './styles';

const idSite = site.id;

const pricesOptionFilter = [{ name: 'price', id: 'price' }, { name: 'expenses', id: 'CFT6' }];

const sitesWithIPTU = ['IWBR', 'WIBR', 'ICBR'];
if (sitesWithIPTU.includes(idSite)) {
  pricesOptionFilter.push({ name: 'IPTU', id: 'CFT400' });
}

const Container = styled.div`
  margin-bottom: 25px;
  width: 100%;
`;

const PriceUniqueSection = ({ siteId, register, errors }) => {
  const { t } = useTranslation();
  const currencySelectOptions = currencyOptionsBySite(siteId);

  const formatParticularOptions = priceOption => {
    if (siteId === 'PLEC') {
      return [currencySelectOptions[1]];
    }
    return priceOption === 'expenses' ? [currencySelectOptions[0]] : currencySelectOptions;
  };

  const changePriceFormat = evt => {
    const nonDigits = /^0+|\D/gi;
    const _value = evt.target.value.replaceAll(nonDigits, '');
    evt.target.value = formatAmount(_value);
  };

  return (
    <>
      {pricesOptionFilter.map(({ name, id }) => (
        <Container key={`pricesKey-${name}-${id}`}>
          <SelectInput
            ref={register}
            label={t(`publisher.step1.module4.${name}.text`)}
            selectId={`${id}.value_unit`}
            inputId={`${id}.value`}
            inputProps={{
              'data-repa': `S1M4_amount_${name}`,
              placeholder: '0',
              onBlur: changePriceFormat,
              onKeyDown: specialCharactersLock,
              onInput: null
            }}
            options={formatParticularOptions(name)}
          />
          {name === 'price' && errors.price && (
            <ErrorMessage data-repa={`S1M4-price-${name}-${id}-error`}>
              {t('publisher.step1.module4.price.validation')}
            </ErrorMessage>
          )}
          {name === 'expenses' && errors.CFT6 && (
            <ErrorMessage data-repa={`S1M4-price-${name}-${id}-error-max`}>{`${t(
              'publisher.step3.module1.validation.max'
            )} ${errors.CFT6.value.message}`}</ErrorMessage>
          )}
          {name === 'IPTU' && errors.CFT400 && (
            <ErrorMessage data-repa={`S1M4-price-${name}-${id}-error-iptu`}>{`${t(
              'publisher.step3.module1.validation.max'
            )} ${errors.CFT400.value.message}`}</ErrorMessage>
          )}
        </Container>
      ))}
    </>
  );
};

export { PriceUniqueSection };
